import React, { useEffect, useState } from "react";
import RanseqStyle from "./Ransep.module.css";
import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse, theme } from "antd";
import AllSamples from "./component/AllSamples";
import Filter from "./component/Filter";

function RanseqIndex() {

 
  const getItems = (panelStyle) => [
    {
      key: "1",
      label: <p className={RanseqStyle.CollTtitle}>All samples</p>,
      children: (
        <AllSamples
         
        />
      ),
      style: panelStyle,
    },
    {
      key: "2",
      label: <p className={RanseqStyle.CollTtitle}>Filter</p>,
      children: <Filter />,
      style: panelStyle,
    },
  ];
  const { token } = theme.useToken();
  const panelStyle = {
    marginBottom: 24,
    borderRadius: token.borderRadiusLG,
    border: "none",
  };
  return (
    <div className={RanseqStyle.Ranseq_app}>
      <p className={RanseqStyle.Ranseq_title}>RNA-seq</p>
      <Collapse
        bordered={false}
        defaultActiveKey={["1", "2"]}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        style={{
          background: "#fff",
          paddingLeft: "40px",
        }}
        items={getItems(panelStyle)}
      />
    </div>
  );
}

export default RanseqIndex;
